import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { baseURL, LOGIN } from "../../Api/Api";
import LoadingSubmit from "../../Components/Loading/Loading";
import Cookie from "cookie-universal";
import { useNavigate } from "react-router-dom";
import "../Auth/Auth.css";

/* ── Study icon cards ─────────────────── */
const studyCards = [
  {
    label: "الرياضيات",
    icon: (
      <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"/>
      </svg>
    ),
  },
  {
    label: "العلوم",
    icon: (
      <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M9 2v6.18C7.24 9.1 6 10.9 6 13c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.1-1.24-3.9-3-4.82V2H9zm3 15c-2.21 0-4-1.79-4-4 0-1.59.93-2.97 2.28-3.66L11 9.1V4h2v5.1l.72.24C15.07 10.03 16 11.41 16 13c0 2.21-1.79 4-4 4z"/>
      </svg>
    ),
  },
  {
    label: "الأدب",
    icon: (
      <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 14v-2h12v2H6z"/>
      </svg>
    ),
  },
  {
    label: "التاريخ",
    icon: (
      <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>
      </svg>
    ),
  },
  {
    label: "الفيزياء",
    icon: (
      <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
  },
  {
    label: "اللغات",
    icon: (
      <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"/>
      </svg>
    ),
  },
];

export default function Login() {
  const [form, setForm] = useState({ user_name: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const navigate = useNavigate();
  const focus = useRef(null);
  const cookie = Cookie();

  useEffect(() => { focus.current?.focus(); }, []);

  function handleChange(e) {
    setErr("");
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/${LOGIN}`, {
        user_name: form.user_name,
        password: form.password,
      });
      const token = res.data.token;
      const name = res.data.admin?.user_name || res.data.student?.name || "";
      const role = res.data.admin?.Role || "admin";
      cookie.set("rasheed", token, { path: "/" });
      cookie.set("role", role, { path: "/" });
      if (name) cookie.set("user_name", name, { path: "/" });
      navigate("/dashboard/users");
    } catch (error) {
      setLoading(false);
      const status = error.response?.status;
      if (status === 401 || status === 400) {
        setErr("اسم المستخدم أو الرمز السري غير صحيح");
      } else if (status === 404) {
        setErr("هذا الحساب غير موجود، تحقق من الاسم");
      } else if (status === 403) {
        setErr("ليس لديك صلاحية الوصول");
      } else if (status >= 500) {
        setErr("خطأ في الخادم، يرجى المحاولة لاحقاً");
      } else if (!error.response) {
        setErr("تعذّر الاتصال بالخادم، تحقق من اتصالك بالإنترنت");
      } else {
        setErr("حدث خطأ غير متوقع، حاول مجدداً");
      }
    }
  }

  return (
    <>
      {loading && <LoadingSubmit />}
      <div className="login-page">

        {/* ── Left decorative panel ── */}
        <div className="login-left">
          <div className="login-brand">
            <div className="login-brand-icon">
              <svg width="36" height="36" fill="white" viewBox="0 0 24 24">
                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 12.5L3 11.09V17c0 2.76 4.03 5 9 5s9-2.24 9-5v-5.91L12 15.5z"/>
              </svg>
            </div>
            <h1>أكادمية التعليم</h1>
            <p>منصة تعليمية متكاملة لجميع المراحل الدراسية</p>
          </div>

          <div className="study-icons">
            {studyCards.map((card, i) => (
              <div key={i} className="study-icon-card">
                {card.icon}
                <span>{card.label}</span>
              </div>
            ))}
          </div>

          <div className="login-quote">
            "العلم نور يضيء الطريق لمن يسعى بإخلاص وتفانٍ"
          </div>
        </div>

        {/* ── Right form panel ── */}
        <div className="login-right">
          <div className="login-form-wrap">
            <span className="login-welcome-tag">مرحباً بك</span>
            <h2>تسجيل الدخول</h2>
            <p className="login-sub">أدخل بياناتك للوصول إلى لوحة التحكم</p>

            {err && (
              <div className="login-error">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                </svg>
                {err}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* Username */}
              <div className="login-field">
                <label htmlFor="user_name">اسم المستخدم</label>
                <div className="login-input-wrap">
                  <span className="login-input-icon">
                    <svg width="17" height="17" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
                    </svg>
                  </span>
                  <input
                    id="user_name"
                    ref={focus}
                    className="login-input"
                    type="text"
                    name="user_name"
                    value={form.user_name}
                    onChange={handleChange}
                    placeholder="أدخل اسم المستخدم..."
                    autoComplete="username"
                    required
                  />
                </div>
              </div>

              {/* Password */}
              <div className="login-field">
                <label htmlFor="password">الرمز السري</label>
                <div className="login-input-wrap">
                  <span className="login-input-icon">
                    <svg width="17" height="17" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                    </svg>
                  </span>
                  <input
                    id="password"
                    className="login-input"
                    type={showPwd ? "text" : "password"}
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="أدخل الرمز السري..."
                    autoComplete="current-password"
                    minLength="6"
                    required
                  />
                  <button
                    type="button"
                    className="pwd-toggle"
                    onClick={() => setShowPwd((p) => !p)}
                    tabIndex={-1}
                    aria-label={showPwd ? "إخفاء الرمز" : "إظهار الرمز"}
                  >
                    {showPwd ? (
                      <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
                      </svg>
                    ) : (
                      <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={loading || !form.user_name || !form.password}
              >
                {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
              </button>
            </form>

            <p className="login-footer-note">
              أكادمية التعليم &copy; {new Date().getFullYear()}
            </p>
          </div>
        </div>

      </div>
    </>
  );
}
